// src/components/Enrollments/components/EnrollmentsHeader.jsx
// ============================================================================
// BLOCK ENR.HDR.0 — Enrollments header controls
// ----------------------------------------------------------------------------
// PURPOSE
//  - Render the page title, rep selector, year input, and CSV export button.
// ============================================================================

import React from 'react';

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import RepSelector from '../../RepSelector.jsx';
import {
  IGNORE_REPS,
  MAX_YEAR,
  MIN_YEAR,
  PAGE_SUBTITLE,
  PAGE_TITLE,
} from '../constants/enrollmentsUi.js';

function EnrollmentsHeader({
  customerSearch,
  loading,
  onExport,
  onCustomerSearchChange,
  onRepChange,
  onRepSearchChange,
  onProductTypeSearchChange,
  onYearChange,
  productTypeSearch,
  repSearch,
  selectedRep,
  selectedYear,
}) {
  return (
    <Stack
      direction={{ xs: 'column', lg: 'row' }}
      spacing={2}
      sx={{
        mb: 2,
        gap: 2,
        width: '100%',
        justifyContent: 'space-between',
        alignItems: { xs: 'flex-start', lg: 'center' },
      }}
    >
      <Stack spacing={0.5}>
        <Typography variant="h4" data-cy="enrollments-title">
          {PAGE_TITLE}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {PAGE_SUBTITLE}
        </Typography>
      </Stack>

      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={2}
        sx={{ alignItems: { xs: 'stretch', md: 'center' }, width: { xs: '100%', lg: 'auto' } }}
      >
        <RepSelector ignoreReps={IGNORE_REPS} onChange={onRepChange} selectedRep={selectedRep} />

        <TextField
          label="Customer"
          size="small"
          value={customerSearch}
          onChange={onCustomerSearchChange}
          sx={{ minWidth: 180 }}
          data-cy="enrollments-customer-search"
        />

        <TextField
          label="Rep Search"
          size="small"
          value={repSearch}
          onChange={onRepSearchChange}
          sx={{ minWidth: 180 }}
          data-cy="enrollments-rep-search"
        />

        <TextField
          label="Product Type"
          size="small"
          value={productTypeSearch}
          onChange={onProductTypeSearchChange}
          sx={{ minWidth: 180 }}
          data-cy="enrollments-product-type-search"
        />

        <TextField
          label="Year"
          type="number"
          size="small"
          value={selectedYear}
          onChange={onYearChange}
          inputProps={{ min: MIN_YEAR, max: MAX_YEAR, step: 1 }}
          sx={{ width: 120 }}
          data-cy="enrollments-year-input"
        />

        <Button
          variant="contained"
          onClick={onExport}
          disabled={!selectedRep || loading}
          data-cy="enrollments-export-button"
        >
          Export CSV
        </Button>
      </Stack>
    </Stack>
  );
}

export default React.memo(EnrollmentsHeader);
